<template>
  <div class="v-token">
    <fieldset class="v-token__fieldset">
      <legend />

      <div class="v-token__inputs">
        <VTokenInput
          v-for="(item, index) in numberOfDigits"
          :key="index"
          :retrievedInputValue="getInputValueByIndex(index)"
          :inputId="`token_input_${index}`"
          :isDisabled="isDisabled"
          :isInvalid="isTokenInvalidLocal"
          :index="index"
          @input="setFieldValue($event, item, index)"
          @focusPreviousField="setFocusOnPrevField($event, index)"
        />
      </div>

      <div class="v-token__message">
        <template v-if="isTokenInvalidLocal && !isDisabled">
          <ErrorCircleSvg />
          <span>
            {{ errorMessage || 'Código inválido' }}
          </span>
        </template>
      </div>
    </fieldset>
  </div>
</template>

<script>
import VTokenInput from '@/components/commons/VToken/VTokenInput.vue';

export default {
  name: 'VToken',
  components: {
    VTokenInput,
  },

  props: {
    retrievedValue: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      numberOfDigits: 6,
      tokenFieldsListModel: [],
      tokenModel: '',
      isTokenInvalidLocal: false,
    };
  },

  computed: {
    isTokenInvalid() {
      return this.isInvalid;
    },
  },

  watch: {
    isTokenInvalid(newValue) {
      this.isTokenInvalidLocal = newValue;
    },

    isTokenInvalidLocal(newValue) {
      this.$emit('update:isInvalid', this.isTokenInvalidLocal);
    },
  },

  methods: {
    setFocusOnPrevField(event, itemIndex) {
      const toFocusFieldIndex = itemIndex - 1 >= 0 ? itemIndex - 1 : 0;

      const toFocusField = document.getElementById(`token_input_${toFocusFieldIndex}`);
      toFocusField.focus();
    },

    setFieldValue(eventValue, item, index) {
      if (eventValue.length === this.numberOfDigits && index === 0) {
        eventValue.split('').forEach((number, idx) => {
          document.getElementById(`token_input_${index + idx}`).value = number;
          this.tokenFieldsListModel[idx] = number;
        });

        this.checkTokenModelFill();
        return;
      }

      const nextTokenField = document.getElementById(`token_input_${index + 1}`);
      this.tokenFieldsListModel[index] = eventValue;
      this.isTokenInvalidLocal = false;

      if (eventValue && nextTokenField) {
        nextTokenField.focus();
      }

      if (this.hasTokenFormatMatched(this.tokenFieldsListModel)) {
        this.checkTokenModelFill();
      }
    },

    hasTokenFormatMatched(tokenValue) {
      let hasTokenFormatMatched = false;

      if (tokenValue) {
        if (Array.isArray(tokenValue) || typeof tokenValue === 'string') {
          hasTokenFormatMatched = tokenValue.length === 6;
        }
      }

      return hasTokenFormatMatched;
    },

    checkTokenModelFill() {
      const isAllFieldsFilled = this.tokenFieldsListModel.every((value, index) => {
        return !!value;
      });

      if (isAllFieldsFilled) {
        this.tokenModel = '';

        for (const item of this.tokenFieldsListModel) {
          this.tokenModel += item;
        }
        this.$emit('tokenHasCompleted', this.tokenModel);
      }
    },

    getInputValueByIndex(index) {
      const itemInputValue = this.retrievedValue ? this.retrievedValue[index] : '';

      return itemInputValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-token {
  display: flex;
  flex-direction: row;
  width: 100%;

  &__fieldset {
    border: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__inputs {
    border: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 16px 0;
    width: 100%;
  }

  &__message {
    color: var(--color-error);
    display: flex;
    flex-direction: row;
    font-size: var(--font-size-1);
    width: 100%;

    svg {
      height: auto;
      margin-right: 5px;
      width: 12px;

      path {
        fill: var(--color-error);
        height: auto;
      }
    }
  }
}
</style>
